import React from "react";

const content = [
  {
    head: "Individualized learning plans (ILPs):",
    des: "We work with teachers to create personalized learning plans tailored to each student's unique needs and strengths. These plans set specific goals, strategies, and accommodations to ensure academic and social success. ",
  },
  {
    head: "Behavioral and emotional support:",
    des: "Our programs include effective strategies to support students' emotional well-being and manage behavioral challenges, fostering a positive and productive learning environment. ",
  },
];
const sailContent = [
  {
    head: "Screening and assessment:",
    des: "The SAIL (Setting up Access for Independence and Learning) Program is crucial for identifying the root causes of academic or behavioral issues. Through comprehensive observation and analysis, SAIL provides a deep understanding of a child's strengths and challenges. ",
  },
  {
    head: "Insightful diagnosis: ",
    des: "Using both standard and non-standard tools, SAIL accurately identifies specific learning difficulties, emotional barriers, or other factors affecting a student's performance. This detailed assessment allows us to tailor interventions effectively. ",
  },
];
const compassContent = [
  {
    head: "Team formulation:",
    des: " We assemble a dedicated team for each child, including educators, therapists, parents, and other professionals, to provide comprehensive support. ",
  },
  {
    head: "Program plan:",
    des: " We develop a detailed plan based on the child's unique needs and strengths, outlining specific goals, strategies, and interventions. ",
  },
  {
    head: "Monthly reviews:",
    des: "We review the child's progress monthly to assess the effectiveness of strategies and make necessary adjustments. ",
  },
  {
    head: "Direct interaction and observation:",
    des: "Bi-monthly interactions and observations offer real-time insights into the child's progress, helping to fine-tune interventions. ",
  },
  {
    head: "Analysis and visualization:",
    des: "Data from assessments and observations are analyzed and visualized to track the child's progress and identify areas needing additional focus. ",
  },
  {
    head: "Course correction and recommendations: ",
    des: "Based on the analysis, the team recommends next steps and adjusts the program plan as needed to ensure continuous progress. ",
  },
];

const According = () => {
  return (
    <>
      <div className="HeroBg2">
        <div className="mx-1 md:mx-[10%] lg:mx-[16%]  lg:py-[5%]">
          <h1 className="flex justify-center text-3xl md:text-5xl lg:text-7xl text-center font-bold text-blue-700 lg:py-[5%]">
            Personalized support plans for every student
          </h1>

          {/* Specialized Program Plan */}
          <div className="">
            <h1 className="font-bold text-base px-3 lg:px-10">
              <span className="font-black text-xl text-pink-500">
                Our specialized program plan:
              </span>
            </h1>
            <div className="grid grid-flow-row lg:grid-cols-2 lg:gap-8 lg:p-8">
              {content.map((item, index) => (
                <details
                  key={index}
                  className="py-8 bg-pink-200 m-2 cursor-pointer rounded-2xl self-start "
                >
                  <summary className="p-3 lg:p-5 text-lg lg:text-xl font-black">
                    {item.head}
                  </summary>
                  <p className="mx-2 lg:h-40 min-h-48 lg:text-base md:text-sm text-sm lg:mx-5 rounded-3xl p-5 bg-pink-50 font-semibold opacity-90">
                    {item.des}
                  </p>
                </details>
              ))}
            </div>
          </div>

          {/* SAIL Program */}
          <div>
            <h1 className="font-medium text-base px-3 lg:px-10">
              <span className="font-black text-xl text-pink-500">
                SAIL program:
              </span>{" "}
              Essential for identifying student challenges
            </h1>

            <div className="grid grid-flow-row lg:grid-cols-2 lg:gap-8 lg:p-8">
              {sailContent.map((item, index) => (
                <details
                  key={index}
                  className="py-8 bg-pink-200 m-2 cursor-pointer rounded-2xl self-start"
                >
                  <summary className="p-3 lg:p-5 text-lg lg:text-xl font-black">
                    {item.head}
                  </summary>
                  <p className="mx-2  min-h-60 lg:text-base md:text-sm text-sm lg:mx-5 rounded-3xl p-5 bg-pink-50 font-semibold opacity-90">
                    {item.des}
                  </p>
                </details>
              ))}
            </div>
          </div>

          {/* COMPASS Program */}
          <div>
            <h1 className="font-medium text-base px-3 lg:px-10">
              <span className="font-black text-xl text-pink-500">
                CoMPASS program:
              </span>{" "}
              Continuous support and coordination
            </h1>
            <div className="grid grid-flow-row lg:grid-cols-2 lg:gap-8 lg:p-8">
              {compassContent.map((item, index) => (
                <details
                  key={index}
                  className="py-8 bg-pink-200 m-2 cursor-pointer rounded-2xl self-start"
                >
                  <summary className="p-3 lg:p-5 text-lg lg:text-xl font-black">
                    {item.head}
                  </summary>
                  <p className="mx-2 min-h-44 lg:text-base md:text-sm text-sm lg:mx-5 rounded-3xl p-5 bg-pink-50 font-semibold opacity-90">
                    {item.des}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default According;
